const product = {
    init: function () {
        this.section = document.querySelector('#main-product');
        this.mountSliders();
    },
    mountSliders: function () {
        const section = document.querySelector('#main-product .left');

        if(this.imgs && this.imgs instanceof Slider) this.imgs.destroy();

        this.imgs = new Slider(section.querySelector('[slider].imgs'));

        if(section.querySelector('[slider].thumbs')){

            let thumbsOptions = {
                navFor: this.imgs,
                navForActivePosition: 1,
                autoPosition:false
            }

            let verticalonPc = {
                vertical: true
            }

            let verticalOnMobile = {
                responsive: [
                    {
                        breakpoint: 1136,
                        settings: {
                            vertical: true
                        }
                    }
                ]
            }

            let horizontalOnMobile = {
                responsive: [
                    {
                        breakpoint: 1136,
                        settings: {
                            vertical: false
                        }
                    }
                ]
            }

            if(section.querySelector('[slider].thumbs').getAttribute('slider-direction') == 'vertical'){
                thumbsOptions = {...thumbsOptions, ...verticalonPc}
            }

            if(section.querySelector('[slider].thumbs').getAttribute('slider-direction-s') == 'vertical'){
                thumbsOptions = {...thumbsOptions, ...verticalOnMobile}
            } else {
                thumbsOptions = {...thumbsOptions, ...horizontalOnMobile}
            }

            if(this.thumbs && this.thumbs instanceof Slider) this.thumbs.destroy();

            this.thumbs = new Slider(section.querySelector('[slider].thumbs'), thumbsOptions);
            this.imgs.nav = this.thumbs;
            this.imgs.buildNav();
            this.thumbs.buildNavFor();
        }

        setTimeout(() => {
            const slides = section.querySelectorAll('.imgs .img');
            slides.forEach((slide, index) => {
                if(slide.classList.contains('video')){
                    slide.productVideo = new productVideo(slide, this.imgs, index);
                }
            })
        }, 1000)
    }
}

class productVideo{
    constructor (element, imgs, index) {

        this.imgs = imgs;
        this.index = index;
        this.element = element;

        this.player = this.element.querySelector('video');
        this.muted = this.element.querySelector('.muted');

        this.element.addEventListener('click', this.toggleMute.bind(this));

        this.imgs.element.addEventListener('changeSlide', (e) => {
            this.onSlideChange(e);
        }, { passive: true });

        this.observer = new IntersectionObserver((e) => {
            this.onIntersection(e);
        })
        this.observer.observe(element);
    }

    play () {
        // this.player.muted = false;
        // this.muted.classList.add('hidden');
        this.player.play();
    }

    pause () {
        this.player.pause();
    }

    toggleMute () {
        if(this.player.muted){
            this.player.muted = false;
            this.muted.classList.add('hidden');
            this.play();
        }
        else{
            this.player.muted = true;
            this.muted.classList.remove('hidden');
            this.play();
        }
    }

    onSlideChange(e) {
        setTimeout(() => {
            if(e.detail.index == this.index) this.play();
            else this.pause();
        }, "500")
    }

    onIntersection([entry]) {
        if(!entry.isIntersecting){
            this.pause();
        }
    }
}

class stickyAtc extends HTMLElement {
    constructor() {
        super();

        this.atc = document.querySelector('.main-product .atc');

        if(!this.atc) return;
        
        new IntersectionObserver(this.callback.bind(this)).observe(this.atc);
    }

    callback (e) {
        let state = e[0].isIntersecting;
        let top = e[0].boundingClientRect.top;
        if(state == false && top < 0) this.classList.add('active');
        else this.classList.remove('active');
    }
}
customElements.define('sticky-atc', stickyAtc);

document.addEventListener('DOMContentLoaded', () => {
    product.init();
})